export default '2.8.0';



// WEBPACK FOOTER //
// ./src/lib/version.js